import { userManager } from '~/utility/BinSentry-ui-utility';
import { LitElement, html } from '~/lib/bn-lit-element';
import { sharedStyles } from '../styles/shared-styles';
import { sessionStyles } from '../styles/session-styles';
import '../common/bn-flash';
import '../common/bn-logo';
import '../common/bn-icon';

class LoginPage extends LitElement {
  static get properties() {
    return {
      error: { type: String, attribute: false },
    };
  }

  static get styles() {
    return [sharedStyles, sessionStyles];
  }

  render() {
    return html`
      <div class="boxes">
        <div class="box">
          <bn-logo></bn-logo>
          <bn-flash id="flash" .banners="${this.error ? [{ content: this.error, type: 'critical' }] : []}"></bn-flash>
          <bn-loading loading-text="Redirecting to sign-in provider..."></bn-loading>
        </div>
      </div>
    `;
  }

  connectedCallback() {
    super.connectedCallback();
    userManager.signinRedirect().catch(err => {
      this.error = err.message || err;
    });
  }
}

window.customElements.define('login-page', LoginPage);
